import { SHIPPER_PAYMENT_LIST_SUCCESS, SHIPPER_PAYMENT_PAY_BATCH_LIST_SUCCESS } from "../constants";

const initialState = {
  list: [],
  batchList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case SHIPPER_PAYMENT_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case SHIPPER_PAYMENT_PAY_BATCH_LIST_SUCCESS:
    return {
      ...state,
      batchList: action.payload
    };
  default:
    return state;
  }
}